// Web-only strings for attachments (keys prefixed `web.attach.` / `web.viewer.`), BOTH languages.
// Apple keys are used wherever they exist: mac.attachFile (the paperclip), channel.dropToAttach
// (the drop overlay), channel.staging.unreadable, common.retry, common.close. The apps' own
// tooLarge/tooMany sentences hard-code "50 MB" / "5 archivos"; the web speaks the server's limits.
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.attach.tooLarge': '«%@» supera el límite de %@ por archivo.',
    'web.attach.tooMany': 'Puedes adjuntar hasta %d archivos por mensaje.',
    'web.attach.unreadable': 'No se pudo leer «%@» (las carpetas no se pueden adjuntar).',
    'web.attach.disabled': 'Este servidor no permite adjuntar archivos.',
    'web.attach.andOthers': '%@ (y %d más)',
    'web.attach.remove': 'Quitar %@',
    'web.attach.failed': 'No se subió',
    'web.attach.uploading': 'Subiendo… %@',
    'web.attach.blockedHint': 'Reintenta o quita los archivos que no se subieron para poder enviar.',
    'web.attach.queuedHint': 'Se enviará en cuanto terminen de subir los archivos',
    'web.attach.lost': 'Los archivos de este mensaje ya no están en este navegador. Descártalo y adjúntalos de nuevo.',
    'web.viewer.label': 'Visor de imágenes',
    'web.viewer.previous': 'Imagen anterior',
    'web.viewer.next': 'Imagen siguiente',
    'web.viewer.zoomIn': 'Acercar',
    'web.viewer.zoomOut': 'Alejar',
    'web.viewer.download': 'Descargar',
    'web.viewer.openOriginal': 'Abrir el original en otra pestaña',
    'web.viewer.counter': '%d de %d',
    'web.viewer.loadFailed': 'No se pudo cargar la imagen.',
    'web.file.openPdf': 'Abrir el PDF en otra pestaña',
    'web.file.download': 'Descargar %@',
  },
  en: {
    'web.attach.tooLarge': '“%@” is over the %@ per-file limit.',
    'web.attach.tooMany': 'You can attach up to %d files per message.',
    'web.attach.unreadable': 'Couldn’t read “%@” (folders can’t be attached).',
    'web.attach.disabled': 'This server doesn’t allow file attachments.',
    'web.attach.andOthers': '%@ (and %d more)',
    'web.attach.remove': 'Remove %@',
    'web.attach.failed': 'Not uploaded',
    'web.attach.uploading': 'Uploading… %@',
    'web.attach.blockedHint': 'Retry or remove the files that didn’t upload to send.',
    'web.attach.queuedHint': 'Sends as soon as the files finish uploading',
    'web.attach.lost': 'This message’s files are no longer in this browser. Discard it and attach them again.',
    'web.viewer.label': 'Image viewer',
    'web.viewer.previous': 'Previous image',
    'web.viewer.next': 'Next image',
    'web.viewer.zoomIn': 'Zoom in',
    'web.viewer.zoomOut': 'Zoom out',
    'web.viewer.download': 'Download',
    'web.viewer.openOriginal': 'Open the original in a new tab',
    'web.viewer.counter': '%d of %d',
    'web.viewer.loadFailed': 'Couldn’t load the image.',
    'web.file.openPdf': 'Open the PDF in a new tab',
    'web.file.download': 'Download %@',
  },
};
